const legalNotices = {
  title: "LEGAL NOTICE",
  intro: {
    title: "USING THE SERVICES",
    paragraphs: [
      "iizenglish develops, publishes and sells educational applications for professionals, organisations, institutions and individuals.",
      "Access to and/or use of iizenglish are subject to the General Terms and Conditions set out below, as well as to the applicable legal provisions.",
      "By using this web app, you indicate that you have read and accept these Terms and agree to abide by and be bound by all such Terms.",
    ],
  },
  editor: {
    title: "ABOUT US",
    paragraphs: [
      "SAS iizenglish registered under the number 883 506 024 R.C.S Paris",
      "Simplified joint-stock company with a capital of 1,000 Euros",
      "Registered office: 23, avenue Foch, 75116 Paris, France",
      "EU VAT No: FR75881212138",
      "Publication manager: Hervé Chevènement",
      "In order to contact us: see Contact page.",
    ],
  },
  contactingUs: {
    title: "CONTACT US",
    paragraphs: [
      "23, avenue Foch, 75116 Paris, France",
      "+33 (0)6 50 70 87 21",
      "contact@iizenglish.com",
    ],
  },
  host: {
    title: "WEB HOST",
    paragraphs: [
      "GETCAAS<br /> 12 rue Albert Einstein<br /> 48000 Mende - France<br />",
      "Contact the web host: https://www.getcaas.io/",
    ],
  },
  attributions: {
    title: "CREDITS",
    paragraphs: [
      "Web development: Coopdev<br /> Web integration: Maëva Rouxel<br /> Graphics: La Petite Planète<br /> Illustration: Bod’Z<br />",
    ],
  },
  intellectualProperty: {
    title: "INTELLECTUAL PROPERTY RIGHTS",
    paragraphs: [
      "iizenglish owns the intellectual property rights or the rights to use all the items available on the Website, including text, images, graphics, logos, icons, sounds and software.",
      "All other trademarks and logos mentioned on this website are the property of their respective owners.",
      "Any reproduction, modification, exploitation of all or part of the site is prohibited without the prior written permission of their owners.",
    ],
  },
  copyrights: {
    title: "COPYRIGHTS",
    paragraphs: [
      "Any unauthorised use of the site or of any of the elements it contains will be considered as constituting an infringement of copyright and will be prosecuted in accordance with Articles L.335-2 of the Intellectual Property Code.",
      "The creation of hypertext links to www.iizenglish.com may only be undertaken with the prior written authorisation of iizenglish.",
      "The use of the information available on this site is under the sole responsibility of the user. iizenglish cannot be held responsible for any damage of any kind whatsoever that may result from the interpretation or use of the information and content available on the site.",
      "iizenglish is not responsible for any error or omission on this website.",
    ],
  },
  warning: {
    title: "GENERAL NOTICE",
    paragraphs: [
      "The consultation of the site www.iizenglish.com is offered to Internet users free of charge and without any guarantee on the part of its editor.",
      "The information available on the site, which comes from external sources, does not guarantee that it is free of errors, nor does it guarantee its completeness, topicality, exhaustiveness or otherwise.",
      "Consequently, it is the responsibility of the Internet user to use the information on the website at his or her own risk and to carry out any verification under his or her sole responsibility.",
      "iizenglish shall not be held responsible for the interpretation made by Internet users, whatever it may be, of all the information and advice offered on its blog, and for the consequences that may arise from it.",
      "The owners of merchant sites, service sites, personal sites, computer sites (etc.) consulted from the site are solely responsible for compliance by them with all the regulations that apply in the context of the services offered to end customers, and in particular, the laws and regulations relating to :",
      [
        "Distance selling",
        "Consumer protection",
        "Misleading or deceptive advertising",
        "The prices",
        "Product compliance",
      ],
    ],
  },
};

export default legalNotices;
